import { atom } from "recoil";
import { IOfficeBankDetails } from "../types";

export const isAddActionState = atom({
  key: "isAddState",
  default: false,
});

export const isEditActionState = atom({
  key: "isEditState",
  default: false,
});

export const hasBank = atom({
  key: "hasBank",
  default: false,
});

export const rowForEditBank = atom<IOfficeBankDetails | undefined>({
  key: "rowForEditBank",
  default: undefined,
});

export const isSavingBank = atom({
  key: "isSavingBank",
  default: false,
});
